export default __webpack_public_path__ + "static/media/AnraizUncle.6a4946a4.png";